import { createRouter, createWebHashHistory } from "vue-router";
import Login from "../views/Login.vue";
import MainBox from "../views/MainBox.vue";
import McnAskfor from "../views/McnAskfor.vue";
import RoutesConfig from "./config"; // 导入子路由配置
import store from "../store/index";

// 主路由：仅定义根级路由（非嵌套路由）
const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/mainbox",
    name: "mainbox",
    component: MainBox, // 后台根容器，子路由会在这里渲染
  },
  {
    path: "/mcnaskfor",
    name: "mcnaskfor",
    component: McnAskfor,
  },
  {
    path: "/",
    redirect: "/login"
  },
];

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 全局路由守卫：控制登录权限 + 动态挂载子路由
router.beforeEach((to, from, next) => {
  console.log('路由跳转目标:', to);
  // 免登录页面直接放行
  if (to.name === "login" || to.name === "mcnaskfor" || to.path === "/official") {
    next();
  } else {
    // 未登录 → 跳登录页
    if (!localStorage.getItem("adtoken")) {
      next({ path: "/login" });
    } else {
      // 未挂载子路由 → 动态挂载
      if (!store.state.isGetterRouter) {
        router.removeRoute("mainbox"); // 先删除旧路由，避免重复
        ConfigRouter(); // 挂载子路由
        next({ path: to.fullPath }); // 重新跳转目标页
      } else {
        next(); // 已挂载 → 直接放行
      }
    }
  }
});

// 动态挂载子路由（核心：将 config.js 的路由添加为 mainbox 的子路由）
const ConfigRouter = () => {
  // 确保 mainbox 路由存在
  if (!router.hasRoute("mainbox")) {
    router.addRoute({
      path: "/mainbox",
      name: "mainbox",
      component: MainBox
    });
  }

  // 遍历子路由配置，按权限添加到 mainbox 下
  RoutesConfig.forEach(item => {
    checkPermission(item) && router.addRoute("mainbox", item);
  });

  // 标记子路由已挂载
  store.commit("changeGetterRouter", true);
};

// 权限校验：控制哪些子路由可访问
const checkPermission = (item) => {
  if (item.requireAdmin) {
    return store.state.userInfo.role === 1 || store.state.userInfo.role === "main_admin";
  }
  return true; // 普通用户默认可访问
};

export default router;
